import { AuthBase } from '../AuthBase';
import {
  TradeRecord,
  idlFactory as tradeHistoryIDL,
  _SERVICE as TradeHistoryActor
} from '@deland-labs/orderbook_trade_list_client';
import { executeWithLogging } from '../utils/errorLogger';
import { CanisterError } from '../utils/exception';
import { parseToCommon } from '../utils/helper';
import { SpotOrderType } from './Fusion';

export interface SpotTradeRecord {
  type: SpotOrderType;
  time: number;
  volume: number;
  price: number;
}

export class TradeHistory extends AuthBase {
  private tradeHistoryCanisterId: string;
  private baseTokenDecimals: number;
  private quoteTokenDecimals: number;
  private priceDecimals: number;
  constructor(
    tradeHistoryCanisterId: string,
    baseTokenDecimals: number,
    quoteTokenDecimals: number,
    priceDecimals: number
  ) {
    super();
    this.tradeHistoryCanisterId = tradeHistoryCanisterId;
    this.baseTokenDecimals = baseTokenDecimals;
    this.quoteTokenDecimals = quoteTokenDecimals;
    this.priceDecimals = priceDecimals;
  }
  /**
   * fetch my trade history
   * @returns
   */
  public fetchUserTradeList = (
    offset: number,
    limit: number
  ): Promise<Array<SpotTradeRecord>> => {
    return executeWithLogging(async () => {
      const tradeHistoryActor = await this.createTradeHistoryActor(
        this.tradeHistoryCanisterId,
        false
      );
      const res = await tradeHistoryActor.get_user_trade_list(offset, limit);
      if ('Ok' in res) return res.Ok.map(this.parseTrade);
      else throw new CanisterError(res.Err);
    });
  };

  /**
   * parse origin trade to spot target trade
   * @param trade trade record
   * @returns
   */
  private parseTrade = (trade: TradeRecord): SpotTradeRecord => {
    return {
      type:
        'Bid' in trade.order_direction ? SpotOrderType.Bid : SpotOrderType.Ask,
      time: parseToCommon(trade.time).toNumber(),
      volume: parseToCommon(trade.volume, this.baseTokenDecimals).toNumber(),
      price: parseToCommon(trade.price, this.priceDecimals).toNumber()
    };
  };

  /**
   * create trade history actor
   * @param tradeHistoryCanisterId  trade history canister id
   * @param anonymous is anonymous access
   * @returns
   */
  private createTradeHistoryActor = (
    tradeHistoryCanisterId: string,
    anonymous: boolean = true
  ) => {
    return this.createActor<TradeHistoryActor>(
      tradeHistoryCanisterId,
      tradeHistoryIDL,
      anonymous
    );
  };
}
